import { GzInventoryWebComponent } from './component/InventoryWebComponent';

export { GzInventoryWebComponent };
